module.exports = __webpack_public_path__ + "static/img/psq.e0babfd.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/about/psq.png
// module id = neOJ
// module chunks = 1